import apiClient from "./axios-client";

/**
 * get Cancel Receipts
 * @returns
 */
export const getCancelCashierCounterReceipt = async (body) => {
  const response = await apiClient.post(
    `receipt/get-cancel-cashier-counter-receipt`,
    body
  );
  return response.data;
  // return {
  //   receiptno: "242514080813982798",
  //   receipttype: "BillReceipt",
  //   lst: [
  //     {
  //       propertycode: "1070601156.00",
  //       propertyname: "श्रीम.मायारामानी रामकली रिझुमल",
  //       modeofpayment: "Cash",
  //       receiptno: "242514080813982798",
  //       receiptDate: "2024-07-09",
  //       paidamount: 4418,
  //     },
  //   ],
  // };
};

/**
 * Cancel Receipt Action
 * @returns
 */
export const cancelReceipt = async (body) => {
  //   Request Body
  // {
  //     "receipttype":"BillReceipt",
  //     "receiptno":"242514080813982798",
  //     "propertycode": "1070601156.00",
  //     "propertyname": "श्रीम.मायारामानी रामकली रिझुमल",
  //     "modeofpayment": "Cash",
  //     "receiptdate": "2024-07-09",
  //     "paidamount": 4418.0,
  //     "remark":"Wrong Receipt"
  // }
  const response = await apiClient.post(
    `receipt/cancel-cashier-counter-receipt`,
    body
  );
  return response.data;
};

/// Zone Officer API's

/**
 * get Zone Officer Cancel Receipts
 * @returns
 */
export const getZoCancelReceipts = async () => {
  // Zone-Key passed in headers
  const response = await apiClient.get(
    `receipt/get-cancel-counter-receipt-details-zo`
  );
  return response.data;
  // return {
  //   lst: [
  //     {
  //       propertycode: "1070601156.00",
  //       propertyname: "श्रीम.मायारामानी रामकली रिझुमल",
  //       modeofpayment: "Cash",
  //       receiptno: "242514080813982798",
  //       receiptDate: "2024-07-09",
  //       receipttype: "Bill Receipt",
  //       remark: "Wrong Receipt",
  //       paidamount: 4418,
  //     },
  //   ],
  // };
};

/**
 * Approve Cancel Receipt
 * @returns
 */
export const approveCancelReceipt = async (body) => {
  //   Request Body
  // {
  //     "receiptno":"242514080813982798",
  //     "receipttype":"BillReceipt"
  // }
  const response = await apiClient.post(
    `receipt/zo-approved-cancel-counter-receipt`,
    body
  );
  return response.data;
};
